// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"6dfd5b14","453":"fa802b6b","702":"ebbbdf40","715":"1fb4119d"}[chunkId] + ".chunk.js";
};